/*
 * @Author: DonWang wangwenqiu@suanier.com
 * @Date: 2023-06-05 15:03:44
 * @LastEditors: liyunfei 3090384495@qq.com
 * @LastEditTime: 2026-04-01 18:39:43
 * @FilePath: \vr-exp-h5-frontend\src\assets\js\lang\it-IT.js
 * @Description:
 *
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved.
 */
import agrEn from './agr-en'
export default {
    // ai报告相关
    ai: {
        report: "Analisi Rapporto IA",
        train: "Piano Formativo",
        loading: "Caricamento in corso...",
        loadingError1: "Impossibile caricare il report",
        loadingError2: "Ci scusiamo per il disagio. Riprova più tardi.",
    },
    login: {
        loginAndRegister: 'Registrati / Accedi',
        registerAndLogin: 'Accedi / Registrati',
        userLogin: 'Accedi',
        title: "L'account creato tramite email e numero di telefono sono indipendenti l'uno dall'altro, per favore",
        mobileLogin: 'Telefono',
        emailLogin: 'Email',
        email: 'E-mail',
        loginBtn: 'Accesso',
        autoLogin: 'Ricordami',
        retransmission: '{item}sec',
        formList: [
            {
                label: 'Inserire il numero di cellulare',
                placeholder: 'Continua',
            },
            {
                label: 'Codice',
                placeholder: 'Inserire il codice di verifica',
            },
            {
                label: 'Per favore inserisci la tua email',
            },
        ],
        btn: {
            submit: 'Crea un account',
            title: 'Per avere dati accurati, è importante inserire altezza, genere ed età corretti.',
        },
        rule: {
            phone: {
                requiredMsg: 'Formato del numero di telefono non valido.',
                patternMsg: 'Numero di telefono non registrato, crea il tuo account.',
            },
            authCode: {
                requiredMsg: 'Codice di verifica errato, per favore reinseriscilo.',
            },
            email: {
                requiredMsg: "Formato dell'email errato.",
                patternMsg: 'Email non registrata, crea il tuo account.',
            },
        },
        codeSuccess: 'Il codice di verifica è stato inviato, controlla',
        success: 'Invio riuscito',
        error: 'Invio fallito',
        loginSuccess: 'Accesso effettuato',
        account: {
            accountTitle: 'Accesso',
            registerTitle: 'Registrati',
            resetTitle: 'Imposta password',
            password: 'Password',
            placeholder: 'Inserisci la tua password',
            codeLogin: 'Accedi con codice di verifica',
            accountLogin: 'Accedi con password',
            forgotPassword: 'Hai dimenticato la password?',
            registerTips:[
                'Non hai un account?', 
                'Registrati', 
                "L'account esiste già",
                'Registrati',
            ],
            checkRule: [
                'Da 8 a 20 caratteri',
                'Deve contenere almeno una lettera maiuscola',
                'Deve contenere almeno una lettera minuscola',
                'Deve contenere almeno un numero', 
                'Le password non corrispondono'
            ],
            errorTips: [
                'Password errata', 
                'Accesso fallito', 
                "L'account non esiste"
            ],
            reset:[
                'Reimposta password', 
                "Prossimo passo",
                'La nuova password non può essere uguale a quella precedente', 
                'Salta',
                'Password impostata con successo'
            ],
            setPasswordTips:'La password deve essere composta da 8 a 20 caratteri e includere lettere maiuscole, lettere minuscole e numeri.',
            confirmPassword: "Conferma la password",
        },
        switchButton: 'Accesso con password',
        switchButton1: 'Accedi con codice di verifica',
        loginTips: "Gli account non registrati verranno registrati automaticamente dopo l'accesso riuscito.",
        otherLogin: 'Altri metodi di accesso',
        newEmailLogin: 'Accesso via e-mail',
        newPhoneLogin: 'Accesso al numero di cellulare',
        bindLineTips:'O',
        bindEmail: 'Accesso con email collegata',
        bindPhone: 'Accesso con numero di telefono collegato',
        bindAndContinue: "Collega e continua",
        bind: "Collega",
        bindEmailTitle: 'Collega e-mail',
        bindEmailTips1: "Info e-mail {item} non trovate",
        bindEmailTips2: "Collega l'e-mail per continuare",
        bindEmailTips3: "Nessuna e-mail collegata. Collega per accedere e recuperare la password.",
        boundTitle: 'Già registrato?',
        boundCenterTitle1:'Se sei un nuovo utente',
        boundCenterTips1:'Crea un account e inizia',
        boundCenterTitle2:'Se hai già un account',
        boundCenterTips2:'Collega per sincronizzare i dati',
        boundCenterTips3:'Si prega di collegare un account registrato',
        boundCenterTips4:'Consigliato',
        boundCenterTips5:'Collega {item} ad account esistente',
        boundCenterTips6:'Dati e report verranno sincronizzati',
        boundButton1: 'Crea account con {item}',
        boundButton2: 'Collega account esistente',
        phoneCode:"Login con SMS",
        phonePassword:"Cellulare e password",
        emailCode:"Login con codice e-mail",
        emailPassword:"E-mail e password",
        accountDoesNotExist:"Questo account non è ancora registrato. Completa la registrazione con un codice di verifica via email o tramite {item}.",
        toRegister:"Registrati",
        bindNow: "Collega ora",
        bindError:[
            'Collegamento fallito',
            'Scollegamento riuscito',
            'Scollegamento Non Riuscito',
            'Autorizzazione Non Riuscita',
            "Autorizzazione Non Riuscita, Impossibile Recuperare le Informazioni dell'Account",
            'Collegamento Riuscito',
            'Account inesistente. Si prega di collegare un account registrato.',
            "Associazione non riuscita. Questo account è già associato all'account {item} [{nickname}].",
            'Autorizzato e registrato come account, la disconnessione non è supportata',
            "L'account non esiste, si prega di utilizzare il codice di verifica per accedere e registrarsi",
        ],
        accountSecurity: {
            faceBook:'Account Facebook',
            google: 'Account Google',
            isBind: 'Non collegato',
            dialogTitle: 'Confermi lo scollegamento?',
            dialogCenter: 'Dopo aver scollegato {item}, non potrai più usarlo per accedere a questo account.',
            bindFailure:'Collegamento fallito',
            bindFailureTips: "Il tuo account {item} è già collegato all'account sottostante. Se vuoi trasferire il collegamento all'account corrente, accedi prima all'account sottostante per scollegarlo.",
            returnButton:'Conferma e torna'
        },
        bindEmailError: [
            "E-mail già esistente."
        ],
    },
    register: {
        mobileRegister: 'Telefono',
        emailRegister: 'Email',
        enroll: 'Il Numero Di Cellulare È Già Registrato',
        search: 'Cerca',
        title: "L'account creato tramite email e numero di telefono sono indipendenti l'uno dall'altro, per favore",
        needRead: {
            agree: "Sono d'accordo",
            privacy: '(Politica sulla privacy)',
        },
        register: 'Registrati',
        check: "Controlla 'Privacy Utente'",
        newUser: 'Registrati',
        form: {
            labelList: ['Nome', '* Genere', '* Altezza', '* Età'],
        },
        placeholder: [
            'Per favore inserisci il tuo nome',
            'Per favore inserisci la tua altezza',
            'Per favore inserisci la tua età',
        ],
        unit: ['Metriche', 'Imperiali', ''],
        sexOptions: {
            male: 'Maschio',
            female: 'Donna',
        },
        btn: 'Invia',
        rules: {
            metricheight: [
                "La gamma dell'altezza va da 2 piedi e 3 pollici a 6 piedi e 7 pollici (70-200 cm), si prega quindi di reinserirlo.",
            ],
            heightMsg: ["La gamma dell'altezza va da 70 a 200 cm, si prega quindi di reinserirlo."],
            ageMsg: ["La gamma dell'età va da 10 a 99 anni, si prega quindi di reinserirlo."],
            agePointMsg: ["Non intero: l'età può essere solo intera, inserisci l'età corretta"],
        },
        success: 'Registrazione effettuata con successo',
        userMessage: 'Inserisci il tuo nome utente',
        verify: 'Inserisci il codice di verifica a 4 cifre',
        errorMsg: "Il formato dell'altezza non supporta i decimali, per favore reinseriscilo",
        enrollEmail: "L'email è registrata.",
        abnormalMsg: 'Anomalia di registrazione',
    },
    model: {
        loading: 'Caricamento...Attendere un momento',
        modelLoading: 'Caricamento del modello 3D',
        tabPane: [
            {
                title: 'Tecnologia Deep Real Sense',
                msg: 'Raccoglie accuratamente i dettagli locali del corpo attraverso la scansione 3D, garantisce una misurazione della circonferenza precisa al millimetro e presenta chiaramente le modifiche alla forma del corpo dopo gli allenamenti.',
            },
            {
                title: 'Algoritmo BDA sulla composizione corporea',
                msg: "Visbody utilizza il sistema di misurazione più avanzato - l'algoritmo BDA - per determinare la composizione corporea. Questo metodo di calcolo basato sul volume corporeo valuterà in modo più preciso i rischi sanitari causati dall'obesità.",
            },
            {
                title: 'Fattori che causano errori',
                msg: 'Indumenti larghi o alcuni ornamenti sul / nel corpo causeranno errori; indossare abiti aderenti o ridurre la quantità di vestiti se si desidera ottenere dati più accurati.',
            },
            {
                title: 'Ottieni il tuo rapporto',
                msg: "Si consiglia di aggiungere ai preferiti l'URL della pagina web per visualizzare facilmente il rapporto in futuro. Puoi anche inviare questo rapporto alla tua casella di posta per salvarlo in seguito.",
            },
        ],
        collect: ['Si prega di aggiungere ai preferiti questa pagina, Facile revisione del rapporto in futuro.', ''],
        know: 'Ho capito',
        reminder: [
            'Gentilmente ricorda',
            'Il tuo modello di avatar 3D è stato generato, scorri a sinistra e a destra per ruotare il modello.',
            "Il tuo rapporto è stato generato e può essere visualizzato cliccando sul pulsante 'Visualizza Rapporto'.",
            'La valutazione del tuo corpo non è riuscita, ti preghiamo di controllare il rapporto sulla composizione corporea.',
            "La misurazione della tua composizione corporea non è riuscita, ti preghiamo di controllare il rapporto sull'analisi posturale.",
            'La tua misura non è andata a buon fine, si prega di tornare al dispositivo e ripetere il test.',
            'La misurazione della composizione corporea non è andata a buon fine, si prega di tornare al dispositivo e ripetere il test.',
            "L'analisi posturale non è andata a buon fine, si prega di tornare al dispositivo e ripetere il test.",
        ],
        btn: {
            viewReport: 'Visualizza report',
            bodyReport: 'Visualizza Rapporto Composizione Corporea',
            postureReport: 'Visualizza Rapporto Postura Corporea',
            lastReport: 'Vedi Ultimo Rapporto',
            loading: 'Caricamento in corso',
        },
    },
    report: {
        btn: {
            download: 'Scarica Il Report',
            send: 'Invia rapporto',
            report: 'Report',
        },
        reportSuccess: 'Successo!',
        tabPane: {
            labelList: [
                'Tempo Misura',
                'Elementi',
                'Composizione corporea',
                'Valutazione della postura',
                'ROM arti superiori',
            ],
        },
        sendEmail: 'Email:',
        requiredMsg: 'Inserisci la tua email',
        patternMsg: `Inserisci l'indirizzo email corretto`,
        send: 'Invia',
        download: 'Scarica Il Report',
        sendReport: 'Invia rapporto',
    },
    sidebar: {
        successMsg: {
            sex: 'Genere cambiato con successo',
            height: 'Altezza modificata con successo',
            age: 'Età modificata con successo',
        },
        logOut: 'Esci',
        personal: 'Centro Personale',
        cut: 'Cambia Unità/Lingua',
        unit: ['Metrico (kg, cm)', 'Imperiale (ft, in, lb)'],
        read: {
            reading: 'Leggi',
            privacy: '(Politica sulla privacy)',
        },
        setting: 'Impostazioni',
        form: {
            labelList: ['Telefono', 'Unità', 'Lingue', 'Soprannome', 'Genere', 'Altezza', 'Età'],
        },
        placeholder: ['Cambia il tuo nome utente', 'Nuovo Genere', 'Aggiornamento Altezza', 'Aggiornamento Età'],
        btn: {
            cancelBtn: 'Cancella',
            accomplishBtn: 'Completa',
            confirmBtn: 'Conferma',
        },
        dialog: [
            'Il genere è uno dei fattori importanti per la misurazione della composizione corporea. I dati misurati dopo la modifica saranno diversi dai dati precedenti. Confermi di volerlo cambiare?',
            "L'altezza è uno dei fattori importanti per la misurazione della composizione corporea. I dati misurati dopo la modifica saranno diversi dai dati precedenti. Confermi di volerlo cambiare?",
            "L'età è uno dei fattori importanti per la misurazione della composizione corporea. I dati misurati dopo la modifica saranno diversi dai dati precedenti. Confermi di volerlo cambiare?",
        ],
        rules: {
            metricheight: ["Si prega di inserire l'intervallo corretto dell'altezza (da 2'  3'' a 6' 7'')"],
            heightMsg: ["Si prega di inserire un'altezza compresa tra i 70cm e i 200cm."],
            ageMsg: [
                "Si prega di inserire l'età compresa tra 10 e 99 anni.",
                "Non intero: l'età può essere solo intera, inserisci l'età corretta",
            ],
        },
        heightMsg: "Si prega di scegliere nuovamente l'altezza.",
        ageMsg: "Si prega di scegliere nuovamente l'età.",
        ModelBinding: 'Sembra che qualcuno abbia già scansionato il codice, si prega di misurare nuovamente!',
        ReportEmpty: {
            title: 'Non hai ancora nessun rapporto disponibile.',
            desc: 'Vieni al Visbody 3D body scanner e prova ancora!',
        },
        changeSort: 'Cambio rapporto prodotto.',
        setPassword: 'Imposta/Modifica password',
        accountSecurity: 'Account e sicurezza',
        describe:
            'Dopo aver cambiato il modello del prodotto, tutti i rapporti di misurazione sotto questo modello verranno visualizzati.',
        describeBtn:
            "Dopo aver cambiato il modello del prodotto, sarai reindirizzato all'ultimo rapporto di misurazione sotto questo modello.",
        descReport: 'Il cambio del rapporto prodotto è avvenuto con successo.',
    },
    modelBinding: {
        desc: 'Sembra che qualcuno abbia già scansionato il codice, si prega di misurare nuovamente!',
    },
    reportEmpty: {
        title: 'Non hai ancora nessun rapporto disponibile.',
        desc: 'Vieni al Visbody 3D body scanner e prova ancora!',
    },
    userInfo: {
        height: 'Altezza:',
        age: 'Età:',
        unit: '',
        weight: 'peso',
    },
    assessment: {
        great: 'Grande',
        good: 'Buono',
        normall: 'Normale',
        weak: 'Debole',
    },
    mass: {
        title: "Panoramica dell'Assessment della Composizione Corporea",
        titles: 'Composizione Corporea',
        springFrame: '',
        massFrame: 'Nessun dato di misurazione per il giorno corrente',
        contrast: 'Scegli un report da confrontare',
        contrastReport: 'Scegli un report da confrontare',
        noRecord: 'Nessun dato.',
        score: 'Punteggio',
        status: 'Il tuo attuale stato di composizione corporea ',
        WT: 'Peso',
        PBF: 'PGC',
        measure: {
            value: 'Valori misurati',
            standardRange: 'Gamma standard',
            comparedWithLastLime: 'Netto',
            comparedNet: 'Netto',
            WT: 'Peso',
            FFM: 'Massa Magra',
            BFM: 'Massa Grassa Corporea',
            LM: 'Massa Muscolare',
            TBW: 'Acqua Corporea',
            SM: 'Massa Muscolare Scheletrica',
            PROTEIN: 'Proteina',
            TM: 'Sali inorganici',
            BMR: 'Tasso metabolico basale',
            WHR: 'Rapporto vita/fianchi',
            BMI: 'IMC',
            PBF: 'PGC',
            VFG: 'Livello di Grasso Viscerale',
            unit: 'kg',
            BMRUnit: 'kcal/g',
        },
        explain: [
            {
                title: 'Peso',
                msg: ' Il peso corporeo è la somma di acqua corporea, proteine, sali inorganici e grasso corporeo.',
            },
            {
                title: 'Massa Magra',
                msg: 'La Massa Magra è il peso corporeo meno il grasso.',
            },
            {
                title: 'Massa Grassa Corporea',
                msg: 'La Massa Grassa Corporea è la somma del grasso sottocutaneo, del grasso viscerale e del grasso intermuscolare.',
            },
            {
                title: 'Massa Muscolare',
                msg: 'La massa muscolare è la massa del tessuto magro del corpo, che comprende il muscolo scheletrico, il muscolo liscio e il muscolo cardiaco.',
            },
            {
                title: 'Acqua Corporea',
                msg: "L'acqua totale rappresenta dal 50% al 70% del peso corporeo, distribuita tra le cellule e i fluidi corporei. La maggior parte si trova nelle cellule muscolari.",
            },
            {
                title: 'Massa Muscolare Scheletrica',
                msg: 'La Massa Muscolare Scheletrica, noto anche come muscolo striato, è attaccato alle ossa ed è uno dei tre tipi di muscoli del corpo.',
            },
            {
                title: 'Proteina',
                msg: 'Le proteine sono sostanze solide che contengono azoto, si trovano in tutte le cellule del corpo e sono la componente principale della massa muscolare.',
            },
            {
                title: 'Sali inorganici',
                msg: 'Il corpo umano è composto da materia organica e inorganica. I sali inorganici costituiscono circa il 5% del peso corporeo.',
            },
            {
                title: 'Tasso Metabolico Basale',
                msg: 'Il metabolismo basale si riferisce alla quantità totale di energia consumata dal corpo in un giorno quando è sveglio e a riposo, non influenzato da esercizio fisico o alimentazione.',
            },
            {
                title: 'Rapporto vita/fianchi',
                msg: " Il rapporto vita/fianchi è il rapporto tra la circonferenza della vita e quella dei fianchi ed è un importante indicatore dell'obesità centrale.",
            },
            {
                title: 'IMC',
                msg: "L'indice di massa corporea (IMC) è usato principalmente per valutare il grado di obesità ed è utilizzato a livello internazionale per determinare se una persona è in sovrappeso o sottopeso.",
            },
            {
                title: 'PGC',
                msg: 'La percentuale di grasso corporeo è il rapporto tra il grasso corporeo e il peso corporeo.',
            },
            {
                title: 'Livello di Grasso Viscerale',
                msg: "Il livello di grasso viscerale è un indicatore importante per valutare l'obesità nascosta.",
            },
            {
                title: 'Acqua intracellulare',
                msg: `L'acqua intracellulare è il fluido corporeo contenuto nelle cellule e rappresenta il componente base del protoplasma.`,
            },
            {
                title: 'Acqua extracellulare',
                msg: `L'acqua extracellulare solitamente si riferisce ai fluidi extracellulari nel corpo umano, compresi il plasma e il liquido interstiziale tra i vasi sanguigni e le cellule tessutali.`,
            },
            {
                title: 'Età Metabolica',
                msg: "L'età metabolica si riferisce alle prestazioni del corpo e alle sue funzioni di salute relative al metabolismo.",
            },
            {
                title: 'Rapporto ECW/TBW',
                msg: "Il rapporto ECW/TBW è la proporzione di acqua extracellulare (ECW) rispetto all’acqua corporea totale (TBW). È un indicatore importante per valutare l’equilibrio dei fluidi corporei.",
            },
        ],
        segment: {
            fat: 'Analisi Segmentale del Grasso',
            muscle: 'Analisi Segmentale della Massa Magra',
            right: 'Destro',
            left: 'Sinistro',
            standard: 'Normale',
            lowStandard: 'Basso',
            superStandard: 'Alto',
            peel: '(Tare)',
        },
    },
    shape: {
        title: 'Panoramica della valutazione corporea',
        titles: 'Postura',
        status: 'La tua attuale condizione fisica',
        suggest: 'Suggerimento,',
        possibility: "c'è la possibilità di",
        models: {
            front: 'Positivo',
            left: 'Profilo sinistro',
            right: 'Profilo destro',
            top: 'Retro',
            low: 'Basso',
            high: 'Alto',
            normal: 'Normale',
        },
        item: {
            deviate: 'Valori misurati',
            result: 'Spiegazione',
            normal: 'Normale',
			keAbnormal: 'Sospetta anomalia',
            abnormal: 'Anomalie',
            head: 'Testa protratta in avanti',
            headSlant: 'Testa inclinata lateralmente',
            roundShoulderLeft: 'Spalla arrotondata a sinistra',
            roundShoulderRight: 'Spalla arrotondata a destra',
            highLowShoudler: ' Differenza di altezza delle spalle',
            pelvis: 'Movimento anteriore/posteriore del bacino',
            leftKneeCheck: 'Valutazione del ginocchio sinistro',
            rightKneeCheck: 'Valutazione del ginocchio destro',
            leg: 'Forma delle gambe',
            leftLeg: 'Gamba sinistra:',
            rightLeg: 'Gamba destra:',
        },
        explain: [
            {
                title: 'Testa protratta in avanti',
                msg: "L'angolo tra il punto dell'orecchio sul lato sinistro e la linea che collega il centro del collo e la linea mediana sul lato sinistro.",
            },
            {
                title: 'Testa inclinata lateralmente',
                msg: "L'angolo tra il punto medio della parte anteriore della testa, il centro del collo e la linea mediana frontale.",
            },
            {
                title: 'Spalla arrotondata a sinistra',
                msg: "L'angolo tra la linea che collega il punto più alto sul lato sinistro della schiena e la tangente alla spalla.",
            },
            {
                title: 'Spalla arrotondata a destra',
                msg: "L'angolo tra la linea che collega il punto più alto sul lato destro della schiena e la tangente alla spalla.",
            },
            {
                title: ' Differenza di altezza delle spalle',
                msg: 'La distanza verticale tra i punti delle spalle sinistra e destra sulla schiena.',
            },
            {
                title: 'Movimento anteriore/posteriore del bacino',
                msg: "L'angolo incluso nella linea che connette il punto centrale del collo, il punto dell'anca e quello alla caviglia sul lato sinistro.",
            },
            {
                title: 'Valutazione del ginocchio sinistro',
                msg: "L'angolo incluso nella linea a tre punti che connette i punti dell'anca, articolazione del ginocchio e caviglia sul lato sinistro.",
            },
            {
                title: 'Valutazione del ginocchio destro',
                msg: "L'incluso angolo nella linea a tre punti che connette i punti dell'anca, articolazione del ginocchio e caviglia sul lato destro.",
            },
            {
                title: 'Forma delle gambe',
                msg: "L'incluso angolo nella linea che unisce i punti dell'anca, articolazione del ginocchio e caviglia nella parte anteriore delle gambe sinistra e destra.",
            },
            {
                title: 'Anteroversione/Retroversione pelvica',
                msg: "L'angolo tra la verticale e il piano formato dalle Spine Iliache Antero-Superiori destra e sinistra e dalla Sinfisi Pubica."
            },
            {
                title: 'Dismetria degli arti inferiori',
                msg: 'La differenza di altezza dal suolo tra i punti più bassi dei solchi glutei destro e sinistro.'
            }
        ],
        exception: [
            {
                title: 'Inclinazione verso sinistra',
                abnormal: 'inclinato verso sinistra',
            },
            {
                title: 'Inclinazione verso destra',
                abnormal: 'inclinato verso destra',
            },
            {
                title: 'Altezza a sinistra',
                abnormal: 'alta a sinistra',
            },
            {
                title: 'Altezza a destra',
                abnormal: 'alta a destra',
            },
            {
                title: 'Inarcamento pelvico posteriore',
                abnormal: 'inarcamento pelvico posteriore',
            },
            {
                title: 'Inarcamento pelvico anteriore',
                abnormal: 'inarcamento pelvico anteriore',
            },
            {
                title: 'Iperestensione del ginocchio sinistro',
                abnormal: 'iperestensione del ginocchio sinistro',
            },
            {
                title: 'Piega in avanti del ginocchio destro',
                abnormal: 'piega in avanti del ginocchio destro',
            },
            {
                title: 'Iperestensione del ginocchio destro',
                abnormal: 'iperestensione del ginocchio destro',
            },
            {
                title: 'Piega in avanti del ginocchio destro',
                abnormal: 'piega in avanti del ginocchio destro',
            },
            {
                title: 'Gambe a forma di K',
                abnormal: 'gambe a forma di K',
            },
            {
                title: 'Gambe a forma di D',
                abnormal: 'gambe a forma di D',
            },
            {
                title: 'Gambe ad X',
                abnormal: 'gambe ad X',
            },
            {
                title: 'Gambe ad O',
                abnormal: 'gambe ad O',
            },
        ],
    },
    newshape: {
        explain: [
            {
                msg: 'Distanza verticale tra le orecchie e la linea gravitazionale del corpo',
            },
            {
                msg: 'Angolo tra la linea che collega le orecchie e il piano orizzontale',
            },
            {
                msg: "Distanza verticale tra l'acromion sinistro e la linea gravitazionale",
            },
            {
                msg: "Distanza verticale tra l'acromion destro e la linea gravitazionale",
            },
            {
                msg: 'Differenza tra le linee che collegano la base del collo e gli acromion su entrambi i lati',
            },
            {
                msg: "Distanza verticale tra l'anca e la linea gravitazionale",
            },
            {
                msg: "Angolo sul piano sagittale tra l'articolazione della caviglia, un punto 1 cm inferiore all'articolazione del ginocchio sinistro e l'articolazione dell'anca",
            },
            {
                msg: "Angolo sul piano sagittale tra l'articolazione della caviglia, un punto 1 cm inferiore all'articolazione del ginocchio destro e l'articolazione dell'anca",
            },
            {
                msg: "Angolo sul piano coronale tra le articolazioni bilaterali dell'anca, del ginocchio e della caviglia",
            },
        ],
        item: {
            pelvis: 'Anteroversione pelvica',
        },
    },
    girth: {
        title: 'Circonferenze',
        present: '(Presenti)',
        tpl: [
            {
                title: 'Collo',
                key: 'girth.tpl.0.key',
            },
            {
                title: 'Bicipite Sinistro',
                key: 'girth.tpl.1.key',
            },
            {
                title: 'Bicipite Destro',
                key: 'girth.tpl.2.key',
            },
            {
                title: 'Petto',
                key: 'girth.tpl.3.key',
            },
            {
                title: 'Vita alta',
                key: 'girth.tpl.4.key',
            },
            {
                title: 'Vita media',
                key: 'girth.tpl.5.key',
            },
            {
                title: 'Fianchi',
                key: 'girth.tpl.6.key',
            },
            {
                title: 'Coscia Sinistra Prossimale',
                key: 'girth.tpl.7.key',
            },
            {
                title: 'Media coscia sinistra',
                key: 'girth.tpl.8.key',
            },
            {
                title: 'Coscia Sinistra Distale',
                key: 'girth.tpl.9.key',
            },
            {
                title: 'Coscia Destra Prossimale',
                key: 'girth.tpl.10.key',
            },
            {
                title: 'Media coscia destra',
                key: 'girth.tpl.11.key',
            },
            {
                title: 'Coscia Destra Distale',
                key: 'girth.tpl.12.key',
            },
            {
                title: 'Polpaccio Sinistro',
                key: 'girth.tpl.13.key',
            },
            {
                title: 'Polpaccio Destro',
                key: 'girth.tpl.14.key',
            },
            {
                title: 'Vita bassa',
                key: 'girth.tpl.15.key',
            },
        ],
    },
    shoulder: {
        title: 'Funzione della spalla',
        model: {
            val: 'Valori misurati',
            scope: 'Gamma standard',
            diff: 'Netto',
        },
        normal: 'Normale',
        normalAll: 'Non sono state rilevate anomalie significative nella funzione della spalla',
        conclusion: 'Conclusione',
        analyse: 'Analisi:',
        suggest: 'Raccomandazione:',
        cause: 'Si prega di consultare un professionista per un ulteriore screening per motivi specifici.',
    },
    reportTips: {
        title: "Sei sicuro di voler eliminare questo rapporto? Una volta eliminato, non potrà essere ripristinato.",
        confirm: "Cancellare",
        success: "Rapporto eliminato",
        partial: "Rapporto eliminato, sincronizzazione di alcuni dati non riuscita; contattare l'amministratore",
        failed: "Eliminazione non riuscita, riprova più tardi.",
        btnMsg: 'OK',
        alaryTips: "Questo report è stato eliminato dall'amministratore. Si passa al rapporto successivo!",
    },
    saveQr: {
        title: 'Rapporto dello scanner corporeo 3D Visbody.',
        btnMsg: "Tieni premuta l'immagine per salvarla sul tuo telefono.",
        tips: "Se non riesci a salvare l'immagine, vai su [Impostazioni] e apri le autorizzazioni corrispondenti.",
    },
    share: {
        title: 'Si prega di copiare il link qui sotto e condividerlo.',
        btnMsg: 'Copia',
    },
    "waist": {
    "title": "Circonferenza vita-addome",
    "hou": "Post.",
    "qian": "Ant."
  },
  "yao_wei_1": "Zona lombare",
  "yao_bu_fen_shu": "Punteggio zona lombare",
  "waist_fen": "Punteggio",
  "yao_wei": "Circonferenza vita",
  "yao_wei_jian_ti_ji": "Volume tra le circonferenze vita",
  "yao_tun_bi": "Rapporto vita/fianchi",
  "lun_kuo_fen_xi": "Analisi del profilo corporeo",
  "bei_bu": "Dorso",
  "tunbu": "Regione glutea",
  "bei_bu_ti_ji": "Volume dorsale",
  "zheng_chang_fan_wei": "Range normale:",
  "shang_ci": "Prec. ",
  "ben_ci": "Att. ",
  "gupen": {
    "zheng_chang": "Normale",
    "qian_qin_yan_chang": "Anteroversione anomala",
    "qian_qin_yi": "Rischio di anteroversione",
    "hou_qin_yi": "Rischio di retroversione",
    "hou_qin_yan_chang": "Retroversione anomala",
    "zuo_chang_yan_chang": "Dismetria anomala (gamba sinistra)",
    "zuo_chang_yi": "Rischio dismetria (gamba sinistra)",
    "you_chang_yi": "Rischio dismetria (gamba destra)",
    "you_chang_yan_chang": "Dismetria anomala (gamba destra)"
  },
  "gao_yao_xian": "Vita alta",
  "gao_yao_zhong_xian": "Linea Mediana Vita Alta",
  "gao_yao_xia_xian": "Linea Inferiore Vita Alta",
  "xiao_yao_shang_xian": "Linea Superiore Vita Bassa",
  "xiao_yao_zhong_xian": "Linea Mediana Vita Bassa",
  "xiao_yao_xian": "Vita bassa",
  "qv_jian1": "Sezione Superiore Vita Alta",
  "qv_jian2": "Sezione Inferiore Vita Alta",
  "qv_jian_zhong": "Sezione Vita Media",
  "qv_jian3": "Sezione Superiore Vita Bassa",
  "qv_jian4": "Sezione Inferiore Vita Bassa",
  "celiang.failed": "Misurazione fallita, si prega di indossare indumenti aderenti e rimanere immobili durante la misurazione",
  "cun-zai-ming-xian-de-tou-bu-qian-qing-huo-ce-wai-jing-zhui-pai-lie-qing-du-pian-yi": "Testa in avanti/inclinata con lieve deviazione cervicale. Fai attenzione alla postura da seduto.",
  "tou-bu-ming-xian-qian-qing-huo-ce-wai-jing-zhui-pai-lie-zhong-du-pian-yi": "Testa in avanti/inclinata con deviazione cervicale. Si consigliano controllo posturale e allenamento.",
  "tou-bu-yan-zhong-qian-qing-huo-ce-wai-jing-zhui-pai-lie-yan-zhong-pian-yi": "Forte inclinazione della testa e deviazione cervicale. Valutazione professionale consigliata.",
  "xiong-zhui-pai-lie-qing-du-pian-yi-ke-neng-dui-sheng-huo-zhi-liang-you-qing-wei-ying-xiang": "Lieve deviazione toracica. Si consiglia miglioramento del controllo posturale.",
  "xiong-zhui-pai-lie-zhong-du-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Deviazione toracica influisce sulla stabilità. Si consigliano esercizi specifici.",
  "xiong-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang-ke-neng-zao-cheng-teng-tong-ji-qi-ta-ji-fa-xing-wen-ti": "Deviazione toracica evidente e asimmetria. Correzione professionale consigliata.",
  "yao-zhui-pai-lie-qing-du-pian-yi-sheng-wu-li-xian-shang-ke-dan-chang-qi-ke-neng-yin-fa-zi-shi-dai-chang": "Lieve deviazione lombare, postura equilibrata. Consigliato allenamento del core.",
  "yao-zhui-pai-lie-zhong-du-pian-yi-sheng-wu-li-xian-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Deviazione lombare influisce sulla stabilità. Consigliati esercizi correttivi.",
  "yao-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang": "Deviazione lombare evidente. Piano di miglioramento professionale consigliato.",
  "jian-jia-ti-ji-xiong-suo-ru-tu-ji-he-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-jing-shen-qu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-jing-bu-ji-rou-bing-jin-hang-shen-zhan-yun-dong": "Ipertonia: elevatore della scapola, SCM e trapezio superiore. Debolezza: flessori profondi del collo. Consigliati stabilizzazione e rilassamento.",
  "zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolorred-jin-zhang-span-you-ce-xiong-suo-ru-tu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Ipertonia: SCM sinistro e scaleno posteriore. Debolezza: SCM destro. Consigliati equilibrio bilaterale e rilassamento cervicale.",
  "you-ce-xiong-suo-ru-tu-ji-span-stylecolorred-jin-zhang-span-zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Ipertonia: SCM destro. Debolezza: SCM sinistro e scaleno posteriore. Consigliati stabilizzazione simmetrica e rilassamento cervicale.",
  "zuo-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Ipertonia: trapezio superiore sinistro. Debolezza: trapezio medio/inferiore. Consigliati allenamento (medio/inferiore) e rilassamento.",
  "kuan-nei-xuan-ji-qun-he-nei-shou-ji-qun-span-stylecolorred-jin-zhang-span-tun-zhong-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-zhong-ji-la-shen-nei-shou-ji-qun": "Ipertonia: rotatori interni e adduttori. Debolezza: gluteo medio. Consigliati allenamento del gluteo medio e stretching.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-nei-shou-ji-qun-la-shen-tun-zhong-ji-he-li-zhuang-ji": "Ipertonia: gluteo medio e piriforme. Debolezza: adduttori, rotatori interni e LCL. Consigliati stabilizzazione gambe e rilassamento glutei.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-dan-ce-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "Ipertonia: gluteo medio e piriforme. Debolezza unilaterale: adduttori, rotatori interni e LCL. Consigliato allenamento bilaterale.",
  "zuo-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Ipertonia: ischiocrurali sinistri e popliteo. Debolezza: quadricipite e soleo. Consigliati allenamento quadricipite/soleo e stretching.",
  "zuo-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Ipertonia: quadricipite sinistro. Debolezza: grande gluteo e ischiocrurali. Consigliati allenamento glutei/catena posteriore e stretching.",
  "you-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Ipertonia: ischiocrurali destri e popliteo. Debolezza: quadricipite e soleo. Consigliati allenamento quadricipite/soleo e stretching.",
  "you-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Ipertonia: quadricipite destro. Debolezza: grande gluteo e ischiocrurali. Consigliati allenamento glutei/catena posteriore e stretching.",
  "ji-zhu-jie-gou-qing-du-yi-chang-jian-yi-jia-qiang-zi-shi-guan-li-he-he-xin-ji-qun-xun-lian": "Lieve deviazione spinale. Fai attenzione alla postura e allena il core.",
  "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-zhuan-ye-jiao-zheng-gan-yu-bing-ding-qi-fu-cha-ping-gu": "Deviazione spinale moderata. Allenamento professionale consigliato.",
  "you-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Ipertonia: trapezio superiore destro. Debolezza: trapezio medio/inferiore. Consigliati allenamento (medio/inferiore) e rilassamento.",
    ...agrEn,
  "neckReport": {
  "title": "Funzionalità cervicale",
  "conclusion": "Valutazione funzionale del collo",
  "loading": "Generazione del report in corso. Attendere.",
  "failed": "Rapporto di sintesi fallita",
  "analysis": "Analisi",
  "suggestion": "Suggerimento",
  "suggestionText": "Consulta un professionista per diagnosi e cure specifiche."
}
}
